export const SUBSTITUTE_REGISTRANT_SUCCESS = 'event-guestside-site/substituteRegistrant/SUBSTITUTE_REGISTRANT_SUCCESS';
export const SUBSTITUTE_REGISTRANT_ERROR = 'event-guestside-site/substituteRegistrant/SUBSTITUTE_REGISTRANT_ERROR';
export const RESET_SUBSTITUTE_REGISTRANT = 'event-guestside-site/substituteRegistrant/SUBSTITUTE_REGISTRANT_PLANNER';
export const SET_FIELD = 'event-guestside-site/substituteRegistrant/SET_FIELD';
export const SET_VALIDATION = 'event-guestside-site/substituteRegistrant/SET_VALIDATION';
export const AUTO_FOCUS_ON = 'event-guestside-site/substituteRegistrant/AUTO_FOCUS_ON';
export const REQUEST_CONFIRMATION = 'event-guestside-site/substituteRegistrant/REQUEST_CONFIRMATION';
export const DENIED_CONFIRMATION = 'event-guestside-site/substituteRegistrant/DENIED_CONFIRMATION';
export const ACCEPTED_CONFIRMATION = 'event-guestside-site/substituteRegistrant/ACCEPTED_CONFIRMATION';

export function substituteRegistrationSuccess() {
  return { type: SUBSTITUTE_REGISTRANT_SUCCESS };
}

export function substituteRegistrationError() {
  return { type: SUBSTITUTE_REGISTRANT_ERROR };
}

export function resetSubstituteRegistration() {
  return { type: RESET_SUBSTITUTE_REGISTRANT };
}

export function setShowConfirmationMessage(substitutionCart) {
  return { type: REQUEST_CONFIRMATION, payload: { substitutionCart } };
}

export function setConfirmationDenied() {
  return { type: DENIED_CONFIRMATION };
}

export function setConfirmationAccepted() {
  return { type: ACCEPTED_CONFIRMATION };
}

export const setSubstituteRegistrantFields = (fieldName, fieldValue) => {
  return { type: SET_FIELD, payload: { fieldName, fieldValue: fieldValue.trim() } };
};

export function turnOnAutoFocus() {
  return { type: AUTO_FOCUS_ON };
}

export function setValidationMessage(validation) {
  return { type: SET_VALIDATION, payload: { value: validation } };
}

const initialState = {
  substituteRegistrationSuccess: false,
  substituteRegistrationError: false,
  showConfirmationMessage: false,
  hasConfirmed: false,
  autoFocus: false,
  substitutionForm: {
    firstName: '',
    lastName: '',
    emailAddress: ''
  },
  validationList: null,
  substitutionCart: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SUBSTITUTE_REGISTRANT_SUCCESS:
      return { ...state, substituteRegistrationSuccess: true, substituteRegistrationError: false,
        substitutionCart: {
          ...state.substitutionCart,
          status: 'COMPLETED'
        }
      };
    case SUBSTITUTE_REGISTRANT_ERROR:
      return { ...state, substituteRegistrationError: true, substituteRegistrationSuccess: false,
        substitutionCart: {
          ...state.substitutionCart,
          status: 'FAILED'
        }
      };
    case RESET_SUBSTITUTE_REGISTRANT:
      return initialState;
    case SET_FIELD:
      return { ...state, substitutionForm: { ...state.substitutionForm,
        [action.payload.fieldName]: action.payload.fieldValue }, validationList: null };
    case AUTO_FOCUS_ON:
      return { ...state, autoFocus: true };
    case REQUEST_CONFIRMATION:
      return { ...state, showConfirmationMessage: true, validationList: null,
        substitutionCart: action.payload.substitutionCart };
    case DENIED_CONFIRMATION:
      return { ...state, showConfirmationMessage: false };
    case ACCEPTED_CONFIRMATION:
      return { ...state, showConfirmationMessage: false, hasConfirmed: true };
    case SET_VALIDATION:
      return { ...state, validationList: action.payload.value };
    default:
      return state;
  }
}
